import React, { useMemo } from "react";
import { DocumentCircularProgress, TextButtonContainer, TextButtonText } from "./styles";
import { CircularProgress } from "@mui/material";
import { IconBaseProps, IconType } from "react-icons/lib";
import { colors } from "@zapalacorp/tokens";

interface DocumentsBadgeProps {
  color?: string;
  text: string;
  renderIcon?: (props?: IconBaseProps) => JSX.Element;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  textLoading?: string;
}

export const TextButton = ({
  renderIcon,
  color = colors.blue500,
  text,
  onClick,
  loading,
  disabled,
  textLoading,
}: DocumentsBadgeProps) => {
  const colorHandled = useMemo(() => (disabled ? colors.gray400 : color), [color, disabled]);

  if (loading)
    return (
      <TextButtonContainer>
        <DocumentCircularProgress size={16} />
        {textLoading}
      </TextButtonContainer>
    );

  return (
    <TextButtonContainer onClick={!loading && !disabled ? onClick : undefined} disabled={disabled}>
      {!loading ? renderIcon?.({ color: colorHandled, size: 18 }) : <CircularProgress size={16} />}
      <TextButtonText color={colorHandled}>{!loading ? text : textLoading ?? text}</TextButtonText>
    </TextButtonContainer>
  );
};
